import { trackEvent } from '@vp/om-newrelic-tracker';
import {
  createTrackingErrorData,
  createTrackingEventData,
} from './newRelicTrackingUtils';

const SUBSCRIPTION_FETCH_FAILURE = 'SUBSCRIPTION_FETCH_FAILURE';
const SUBSCRIPTION_CHANGE_FAILURE = 'SUBSCRIPTION_CHANGE_FAILURE';
const MANAGE_TEXT_ALERTS_BUTTON = 'MANAGE_TEXT_ALERTS_BUTTON';
const SUBSCRIPTION_UNSUBSCRIBE_FAILURE = 'SUBSCRIPTION_UNSUBSCRIBE_FAILURE';

/**
 * Report a metric whenever a subscription change fails
 * @param shopperId
 * @param {object} additionalData
 */
export const trackSubscriptionChangeFailure = (
  shopperId: string,
  additionalData: object
) => {
  const eventData = createTrackingErrorData(
    SUBSCRIPTION_CHANGE_FAILURE,
    {},
    shopperId,
    additionalData
  );
  trackEvent(eventData);
};

/**
 * Report a metric whenever a subscription unsubscribe request fails
 * @param shopperId
 * @param {object} additionalData
 */
export const trackSubscriptionUnsubscribeFailure = (
  shopperId: string,
  additionalData: object
) => {
  const eventData = createTrackingErrorData(
    SUBSCRIPTION_UNSUBSCRIBE_FAILURE,
    {},
    shopperId,
    additionalData
  );
  trackEvent(eventData);
};

/**
 * Report a metric when a user clicks the "manage text alerts" button
 * @param shopperId
 * @param {object} additionalData
 */
export const trackManageTextAlertsClicked = (
  shopperId = '',
  additionalData: object = {}
) => {
  trackEvent({
    eventName: MANAGE_TEXT_ALERTS_BUTTON,
    ...createTrackingEventData(
      MANAGE_TEXT_ALERTS_BUTTON,
      shopperId,
      additionalData
    ),
  });
};

/**
 * Report a metric whenever a subscription fetch fails
 * @param orderNumber
 * @param {object} additionalData
 */
export const trackSubscriptionFetchFailure = (
  orderNumber: string,
  additionalData: object
) => {
  const eventData = createTrackingErrorData(
    SUBSCRIPTION_FETCH_FAILURE,
    {},
    orderNumber,
    additionalData
  );
  trackEvent(eventData);
};
